import { render, staticRenderFns } from "./EventPopupModal.vue?vue&type=template&id=221b2550&scoped=true&"
import script from "./EventPopupModal.vue?vue&type=script&lang=ts&"
export * from "./EventPopupModal.vue?vue&type=script&lang=ts&"
import style0 from "./EventPopupModal.vue?vue&type=style&index=0&id=221b2550&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221b2550",
  null
  
)

export default component.exports